import React from 'react';

export default function IconTitleValue(props) {
    return (<div className={props.className ? props.className + " horizontalScreen marginSmall" :
        "horizontalScreen"} style={{textAlign: "right"}} onClick={props.onClick ? props.onClick : undefined}>
        <table className={props.fullWidth ? "fullWidth" : ""}>
            <tbody>
            <tr>
                {(props.icon && !props.flip) &&
                <td style={{position: "relative"}}>
                    {(props.badgenumber > 0) &&
                    <table className="smallCircleGreen smallIcon_1 whiteColor smallText center"
                           style={{position: "absolute", top: "0", left: "-0.8em"}}>
                        <tbody>
                        <tr>
                            <td>
                                {props.badgenumber}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    }
                    {props.icon}
                </td>
                }
                <td>
                    <div
                        className={props.titleClassName ? props.titleClassName + " singleLine mediumText marginRightSmall" :
                            "mediumText marginRightSmall singleLine"}>
                        <label>
                            {props.title}
                        </label>
                    </div>
                </td>
                <td>
                    <div  className={props.valueClassName ?
                        props.valueClassName + " marginRightSmall " :
                        "mediumTextBold marginRightSmall"}
                         onClick={props.onValueClick ? props.onValueClick : undefined}>
                        {props.valueIsLink ?
                            <a className="mediumTextBold marginRightSmall"
                               style={{display: "table-cell"}}
                               href={"//" + props.value}
                               target="_blank"
                               rel="noopener noreferrer">
                                {props.value}
                            </a> :
                            <label className={props.valueClassMessage ?
                                props.valueClassMessage + " marginRightSmall " :
                                " marginRightSmall"}>
                                {(props.maxLength && props.value.length > props.maxLength) ?
                                    props.value.substring(0, props.maxLength) + " ..." :
                                    props.value
                                }
                            </label>
                        }
                    </div>
                </td>
                {(props.icon && props.flip) &&
                <td>
                    <div className="toLeft">
                        {props.icon}
                    </div>
                </td>
                }
                {(props.secondValue) &&
                <td>
                    <div>
                        <label className={props.secondValueClassName ?
                            "mediumTextBold marginRightSmall " + props.secondValueClassName :
                            "mediumTextBold marginRightSmall blueColor"
                        }>
                            {props.secondValue}
                        </label>
                    </div>
                </td>
                }
            </tr>
            </tbody>
        </table>
    </div>)
}